






import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BaseLoading extends Vue {}
